import styled from 'styled-components'

const ListItemText = styled.div`
  display: inline-block;
  flex: 1;
  overflow: hidden;
`
export default ListItemText;
